import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IProfileSchema } from '../types/ProfileSchema';
import { IProfileResponse } from '../../api/types';
import { profileApi } from '../../api/profileApi';

const initialState: IProfileSchema = {
  data: null,
  isLoading: false,
  error: null,
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state: Draft<IProfileSchema>, action: PayloadAction<IProfileResponse | null>) => {
      state.data = action.payload;
    },
    clearProfile: (state: Draft<IProfileSchema>) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        profileApi.endpoints.getMyProfile.matchPending,
        (state: Draft<IProfileSchema>) => {
          state.isLoading = true;
          state.error = null;
          // НЕ очищаем data, чтобы сохранить текущие данные во время рефетча
        },
      )
      .addMatcher(
        profileApi.endpoints.getMyProfile.matchFulfilled,
        (state: Draft<IProfileSchema>, action) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        },
      )
      .addMatcher(
        profileApi.endpoints.getMyProfile.matchRejected,
        (state: Draft<IProfileSchema>, action) => {
          state.isLoading = false;
          state.error = action.error;
        },
      );
  },
});

export const { actions: profileActions } = profileSlice;
export const { reducer: profileReducer } = profileSlice;
